const mutations = {
  mutationPolicy(state, payload) {
    state.policy = payload;
  },

  mutationPolicies(state, payload) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.policies[payload.tab] = payload.responseData;
    } else {
      state.policies = payload;
    }
  },

  mutationPoliciesMeta(state, payload) {
    state.policiesMeta = payload;
  },

  mutationPartners(state, payload) {
    state.partners = payload;
  },

  mutationProductCategories(state, payload) {
    state.productCategories = payload;
  },
};

export default mutations;
